import * as Yup from 'yup';
import { Nullable } from '@typings/global';
import { IUser } from './interfaces';

export class UsersModel implements Nullable<IUser>  {
  id: string | null = null;
  firstName: string | null = null;
  lastName: string | null = null;
  email: string | null = null;
  altEmail: string | null = null;
  phoneNumber: string | null = null;
  phoneExtension: string | null = null;
  isActive: boolean | null = null;
  isDeleted: boolean | null = null;
  officeLocationId: string | null = '';
  phoneSystemUserId?: number | null = null;
  trainingPeriodId?: string | null = null;
  terminationDate?: string | null = null;
  paySystemUserId: string | null = null;
  isAcumaticaRecordExist: boolean | null = null;

  constructor(data?: Nullable<IUser>) {
    if (data) {
      this.id = data.id;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.phoneNumber = data.phoneNumber;
      this.email = data.email;
      this.altEmail = data.altEmail;
      this.phoneExtension = data.phoneExtension;
      this.isActive = data.isActive;
      this.isDeleted = data.isDeleted;
      this.phoneSystemUserId = data.phoneSystemUserId;
      this.trainingPeriodId = data.trainingPeriodId;
      this.officeLocationId = data.officeLocationId;
      this.terminationDate = data.terminationDate;
      this.paySystemUserId = data.paySystemUserId;
      this.isAcumaticaRecordExist = data.isAcumaticaRecordExist;
    }
  }
}

export const usersValidationSchema = Yup.object().shape({
  firstName: Yup.string().nullable().required().max(128, 'First Name should be max 128 symbols'),
  lastName: Yup.string().nullable().required().max(128, 'Last Name should be max 128 symbols'),
  phoneNumber: Yup.string().nullable().phone(),
  email: Yup.string().email().required().max(128, 'Email Address should be max 128 symbols').email(),
  altEmail: Yup.string().email().required().max(128, 'Alternate Email Address should be max 128 symbols').email(),
  phoneExtension: Yup.number().nullable(),
  phoneSystemUserId: Yup.number().nullable(),
  trainingPeriodId: Yup.string().nullable(),
  officeLocationId: Yup.string().nullable(),
  terminationDate: Yup.string().nullable(),
  paySystemUserId: Yup.number().nullable(),
  isAcumaticaRecordExist: Yup.boolean().nullable(),
});
